<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-lg-6">
          <validated-form-select name="status" :options="statuses" v-model="status"
                                 label="Staatus:" placeholder="- Vali staatus -"
                                 validate="required" :validator="$validator"/>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <submit-button class="float-right" variant="primary">Salvesta</submit-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import ValidatedFormSelect from '@/components/ValidatedFormSelect'
  import gateway from '@/services/gateway'
  import {utils} from '@/services/Configuration'

  export default {
    components: {ValidatedFormSelect},
    props: ['client'],
    data() {
      return {
        status: null,
        statuses: [],
      }
    },
    created() {
      this.status = this.client.status && this.client.status.value ? this.client.status.value : null
      gateway.get("/classifiers?name=client.status").then(r => this.statuses.splice(1, 0, ...utils.asSelectOptions(r.data)))
    },
    methods: {
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          gateway.post(`/clients/${this.client.id}/status`, {status: this.status})
            .then(() => this.$notifications.info('Kliendi staatus on muudetud'))
            .then(r => this.$emit('done'))
        })
      },
    },
  }
</script>
